export default {

    menuIconSvg: function() {

        return `<svg id="Layer_1" width="25" height="25" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
\t viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"> \n" +
                                               "<path class="st0" d="M0,0h24v24H0V0z" style="opacity: 0;"/>\n" +
                                              "<path class="svg-secondary-color" d="M3,18h18v-2H3V18z M3,13h18v-2H3V13z M3,6v2h18V6H3z"/>\n" +
                                            "</svg>`;
    }
};



// WEBPACK FOOTER //
// ./src/common/plugins/svg/MenuIconPlugin.js